import styled from "styled-components"

const Wrapper = styled.footer`
  border-top: 1px solid rgba(0, 0, 0, 0.15);
  margin-top: 50px;
  padding: 17px 0;

  @media only screen and (min-width: ${props => props.theme.mq.small}) {
    margin-top: 90px;
    padding: 38px 0;
  }

  > div {
    align-items: center;
    display: flex;
    justify-content: space-between;
  }
`

const Links = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: -2px -7.5px;

  @media only screen and (min-width: ${props => props.theme.mq.small}) {
    margin: -5px -10px;
  }

  a {
    font-size: 11px;
    font-weight: ${props => props.theme.title.w};
    padding: 2px 7.5px;
    transition: color 0.3s;

    @media only screen and (min-width: ${props => props.theme.mq.small}) {
      font-size: 13px;
      padding: 5px 10px;
    }

    .no-touchevents &:hover {
      color: ${props => props.theme.colors.primary};
    }
  }
`

const Copy = styled.small`
  color: ${props => props.theme.colors.lightgrey};
  display: block;
  font-size: 11px;
  letter-spacing: 0.36px;
  margin-top: 5px;

  @media only screen and (min-width: ${props => props.theme.mq.small}) {
    font-size: 12px;
    margin-top: 7px;
  }
`

const Social = styled.div`
  align-items: center;
  display: flex;

  @media only screen and (max-width: calc(${props => props.theme.mq.small} - 1px)) {
    display: none;
  }

  > a {
    transition: opacity .3s;

    &:not(:last-child) {
      margin-right: 20px;
    }

    .no-touchevents &:hover {
      opacity: .7;
    }
  }
`

export const sFooter = {
  Wrapper,
  Links,
  Copy,
  Social,
}
